module.exports = __webpack_public_path__ + "static/media/invoice_wholesale.cac0e615.png";